import { useState } from "react";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { Header } from "@/components/layout/header";
import { BottomNav } from "@/components/layout/bottom-nav";
import { Footer } from "@/components/layout/footer";
import { HeroSection, FaithKeywords } from "@/components/sections/hero-section";
import { InfoCards } from "@/components/sections/info-cards";
import { RegistrationModal } from "@/components/registration-modal";
import { SermonModal } from "@/components/sermon-modal";
import { CheckinPage } from "@/components/checkin/checkin-page";
import { MemberDashboard } from "@/components/dashboard/member-dashboard";
import { AdminDashboard } from "@/components/admin/admin-dashboard";
import { ProtectedRoute } from "@/components/auth/protected-route";

// 랜딩 페이지 (기존 메인)
function LandingPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSermonModalOpen, setIsSermonModalOpen] = useState(false);

  const handleCTAClick = () => {
    setIsModalOpen(true);
  };

  const handleSermonClick = () => {
    setIsSermonModalOpen(true);
  };

  return (
    <div className="bg-background text-foreground font-body transition-colors duration-300 min-h-screen flex flex-col">
      <Header />

      <main className="flex-grow pt-16 pb-32">
        <HeroSection onCTAClick={handleCTAClick} />
        <FaithKeywords />
        <InfoCards />

        {/* Decorative Icons */}
        <div className="mt-8 mb-4 px-6 text-center opacity-60">
          <span className="text-primary text-sm">❤️</span>
          <span className="text-primary text-lg mx-2">⭐</span>
          <span className="text-primary text-sm">⛪</span>
        </div>
      </main>

      <Footer />
      <BottomNav onCTAClick={handleCTAClick} onSermonClick={handleSermonClick} />
      <RegistrationModal open={isModalOpen} onOpenChange={setIsModalOpen} />
      <SermonModal open={isSermonModalOpen} onOpenChange={setIsSermonModalOpen} />
    </div>
  );
}

// 체크인 페이지 래퍼
function CheckinPageWrapper() {
  const { token } = useParams<{ token: string }>();
  return <CheckinPage token={token ?? ""} />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 랜딩 페이지 */}
        <Route path="/" element={<LandingPage />} />

        {/* 체크인 (QR 스캔 후 도착) */}
        <Route path="/checkin/:token" element={<CheckinPageWrapper />} />

        {/* 회원 전용 - 대시보드 */}
        <Route
          path="/app"
          element={
            <ProtectedRoute>
              <MemberDashboard />
            </ProtectedRoute>
          }
        />

        {/* Admin 전용 */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireAdmin>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
